/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//
export default {
  'navigation.global-shortcuts.all-sites': 'All sites',
  'navigation.global-shortcuts.apps.align': 'Align',
  'navigation.global-shortcuts.apps.analytics': 'Analytics',
  'navigation.global-shortcuts.apps.assets': 'Assets',
  'navigation.global-shortcuts.apps.bitbucket': 'Bitbucket',
  'navigation.global-shortcuts.apps.company-hub': 'Company Hub',
  'navigation.global-shortcuts.apps.compass': 'Compass',
  'navigation.global-shortcuts.apps.confluence': 'Confluence',
  'navigation.global-shortcuts.apps.focus': 'Focus',
  'navigation.global-shortcuts.apps.goals': 'Goals',
  'navigation.global-shortcuts.apps.home': 'Home',
  'navigation.global-shortcuts.apps.jira': 'Jira',
  'navigation.global-shortcuts.apps.jira-product-discovery': 'Jira Product Discovery',
  'navigation.global-shortcuts.apps.jira-service-management': 'Jira Service Management',
  'navigation.global-shortcuts.apps.loom': 'Loom',
  'navigation.global-shortcuts.apps.opsgenie': 'Opsgenie',
  'navigation.global-shortcuts.apps.projects': 'Projects',
  'navigation.global-shortcuts.apps.studio': 'Studio',
  'navigation.global-shortcuts.apps.talent': 'Talent',
  'navigation.global-shortcuts.apps.teams': 'Teams',
  'navigation.global-shortcuts.apps.trello': 'Trello',
  'navigation.global-shortcuts.menu-expand-item.close-button-aria-label': 'Close',
  'navigation.global-shortcuts.menu-expand-item.site-aria-label': '{name} site',
  'navigation.global-shortcuts.menu-link-item.disabled-item-aria-label': '(currently unavailable)',
  'navigation.global-shortcuts.menu-link-item.link-external-item-label': 'Open external link icon',
  'navigation.global-shortcuts.menu-link-item.loading-item-aria-label': '(loading)',
  'navigation.global-shortcuts.menu-loading-item.loading-item-aria-label': '(loading)',
  'navigation.global-shortcuts.shortcut-action.open-menu-label': 'open menu',
  'navigation.global-shortcuts.sites': '{productName} sites',
};
